export const reportingAuditState = {
    name: 'app.reporting.audit',
    abstract: true,
    url: '/audit'
};

export const reportingAuditDashboardState = {
    name: 'app.reporting.audit.dashboard',
    url: '',
    component: 'dashboard'
};

export const reportingAuditHistoryState = {
    name: 'app.reporting.audit.history',
    redirectTo: 'app.reporting.audit.history.listing',
    url: '/history',
    component: 'tabs'
};

export const reportingAuditHistoryListingState = {
    name: 'app.reporting.audit.history.listing',
    url: '',
    component: 'reportingAuditGrid'
};

// export const reportingAuditGenerateState = {
//     name: 'app.reporting.audit.generate',
//     url: '/generate?id',
//     component: 'reportingAuditGenerate'
// };

export const reportingAuditAddState = {
    name: 'app.reporting.audit.generate',
    redirectTo: 'app.reporting.audit.generate.add',
    url: '/generate',
    component: 'tabs'
};

export const reportingAuditGenerateState = {
    name: 'app.reporting.audit.generate.add',
    url: '',
    component: 'reportingAuditGenerate',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'AUDIT_REPORT_RESET',
            id: 'auditReport'
        });
    }
};
